'use es6';

import { Component, Fragment } from 'react';
import { H4 } from 'foundations-components/transitional/components/H4';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { connect } from 'react-redux';
import { getShouldUseResponsiveBreakpoints } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getModuleVersions, getModuleHasUpgradeAvailable } from 'ContentEditorUI/redux/selectors/moduleVersionsSelectors';
import { getFetchModuleVersionsRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { fetchModuleVersions } from 'ContentEditorUI/redux/actions/moduleVersionsActions';
import { requestSucceeded } from 'redux-request-state/util/requestStateCheckers';
import ContentRoutes from 'ContentUtils/Routes';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { SIDEBAR_HEADER_HEIGHT } from '../lib/sidebar/constants';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  shouldUseResponsiveBreakpoints: getShouldUseResponsiveBreakpoints(state),
  isReadOnlyMode: getIsReadOnlyMode(state),
  moduleVersions: getModuleVersions(state),
  moduleVersionsRequestStatus: getFetchModuleVersionsRequest(state),
  modulehasUpgradeAvailable: getModuleHasUpgradeAvailable(state)
});
const mapDispatchToProps = {
  fetchModuleVersions
};

/**
 * @param {Object} props
 * @param {React.ReactNode} [props.backLink] (optional)
 * @param {React.ReactNode} props.headerLabel (required)
 * @param {boolean} props.shouldUseResponsiveBreakpoints (required)
 * @param {boolean} props.isReadOnlyMode (required)
 * @param {React.ReactNode} [props.breadcrumbs] (optional)
 * @param {Function} [props.closePatagoniaSidebarCallback] (optional)
 * @param {Function} props.fetchModuleVersions (required)
 * @param {Object} props.moduleVersionsRequestStatus (required)
 * @param {Object} [props.moduleSchema] (optional)
 * @param {boolean} [props.modulehasUpgradeAvailable] (optional)
 */
class SidebarHeaderContainer extends Component {
  componentDidMount() {
    const {
      moduleVersionsRequestStatus,
      moduleSchema
    } = this.props;
    const isDefaultModule = moduleSchema && moduleSchema.default;
    if (isDefaultModule && !requestSucceeded(moduleVersionsRequestStatus)) {
      this.props.fetchModuleVersions();
    }
  }
  renderUpgradeAlert() {
    return /*#__PURE__*/_jsx("div", {
      style: {
        position: 'relative',
        zIndex: 9
      },
      children: /*#__PURE__*/_jsx(Alert, {
        type: "info",
        marginInline: 600,
        marginBlockEnd: 400,
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "moduleVersioning.moduleFormAlert_jsx",
          options: {
            external: true,
            href: ContentRoutes.settings('themes')
          },
          elements: {
            Link
          }
        })
      })
    });
  }
  render() {
    const {
      headerLabel,
      breadcrumbs,
      closePatagoniaSidebarCallback,
      modulehasUpgradeAvailable
    } = this.props;
    const headerContainerContents = /*#__PURE__*/_jsxs(Fragment, {
      children: [breadcrumbs, /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        blockSize: !modulehasUpgradeAvailable && !breadcrumbs ? `${SIDEBAR_HEADER_HEIGHT}px` : `${SIDEBAR_HEADER_HEIGHT - 36}px`,
        paddingBlock: 100,
        flexGrow: 0,
        flexShrink: 0,
        children: [/*#__PURE__*/_jsx(Box, {
          paddingInline: 500,
          children: /*#__PURE__*/_jsx(Flex, {
            flexDirection: "column",
            alignItems: "start",
            children: /*#__PURE__*/_jsx(H4, {
              margin: "0",
              children: /*#__PURE__*/_jsx(TruncateString, {
                children: headerLabel
              })
            })
          })
        }), /*#__PURE__*/_jsx(CloseButton, {
          position: "absolute",
          color: "icon-core-subtle",
          insetInlineEnd: 600,
          size: "md",
          onClick: () => closePatagoniaSidebarCallback(),
          "data-selenium": "save-and-close-sidebar"
        })]
      }), modulehasUpgradeAvailable && this.renderUpgradeAlert()]
    });
    return headerContainerContents;
  }
}
SidebarHeaderContainer.contextType = TourContext;
export default connect(mapStateToProps, mapDispatchToProps)(SidebarHeaderContainer);